import { render, staticRenderFns } from "./topSection.vue?vue&type=template&id=1985f9bc&scoped=true&lang=html&"
import script from "./topSection.vue?vue&type=script&lang=js&"
export * from "./topSection.vue?vue&type=script&lang=js&"
import style0 from "./topSection.vue?vue&type=style&index=0&id=1985f9bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1985f9bc",
  null
  
)

export default component.exports